import makeStorage from './storage';

// Utilitário para gerenciar os filtros da página AnalisesDrf no localStorage
const drfFiltersStorage = makeStorage('drf_filters', 'localStorage', {});

export interface DrfFiltersStorageData {
  dataInicio: string;
  dataFim: string;
  establishmentId: number | string | null;
}

export const DrfFiltersStorageUtils = {
  // Salva filtros no localStorage
  save: (data: DrfFiltersStorageData) => {
    drfFiltersStorage.save(data);
  },

  // Recupera filtros do localStorage
  get: (): DrfFiltersStorageData | null => {
    const data = drfFiltersStorage.get();
    return data && (data.dataInicio || data.dataFim) ? data : null;
  },

  // Remove filtros do localStorage
  clear: () => {
    drfFiltersStorage.remove();
  }
};

export default DrfFiltersStorageUtils;
